import Decimal from 'decimal.js'
import config from '@/config'
window.Decimal = Decimal

function loadScript(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.type = 'module'
    script.src = url
    script.async = true
    script.onload = () => {
      // Resolve with the script element once it's loaded
      resolve(script)
    }
    script.onerror = () => reject(new Error(`Failed to load script: ${url}`))
    document.body.appendChild(script)
  })
}

loadScript(`${config.apiRoot}/api/scripts/positionCalculation`).catch(error => {
  console.error('Script loading error:', error)
})

const getCalculationValues = (position) => window.getCalculationValues(position)

export default {
  getCalculationValues,
  calculatePricesBasedOnPriceNet: function(position) {
    return window.calculatePricesBasedOnPriceNet(position)
  },

  calculatePricesBasedOnPriceGross: function(position) {
    return window.calculatePricesBasedOnPriceGross(position)
  },
}
